module.exports = __webpack_public_path__ + "static/lights17-dac6693f3ee785c80eb2b6c239306953.jpg";